export * from './berichte-sorter.component';
export * from './berichte-sorter.component.module';